import React from 'react';
import { StyleSheet, Text, TextInput, View } from '../base_components';

import ImageButton from '../buttons/image_button';

const styles = StyleSheet.create({
  labelInputView: {
    marginTop: '1rem',
    marginLeft: '1rem',
    marginRight: '1rem',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  label: {
    marginLeft: '0.5rem',
    color: 'black',
    fontSize: '1.5rem',
    fontWeight: '500',
  },
  inputWrapper: {
    marginTop: '0.5rem',
    alignSelf: 'stretch',
    height: '3.5rem',
    backgroundColor: '#eee',
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: '#ddd',
    borderRadius: '0.5rem',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'hidden',
  },
  input: {
    flex: 1,
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    color: '#333',
    fontSize: '1.4rem',
  },
  scanButton: {
    width: '4rem',
    height: '4rem',
    padding: '1rem',
    borderRadius: '0.5rem',
  },
});

const SCAN_IMG = require('../../assets/img/scan_white.png');

export default function LabelInput(props) {
  const { style, text, children, onScanPress, ...other } = props;

  let scan = null;
  if (onScanPress) {
    scan = (
      <ImageButton
        style={styles.scanButton}
        source={SCAN_IMG}
        underlayColor='rgba(255,255,255,0.2)'
        onPress={onScanPress}
      />
    );
  }
  let inner = null;
  if (children) {
    inner = children;
  } else {
    inner = (
      <TextInput
        style={styles.input}
        placeholderTextColor='#aaa'
        autoCorrect={false}
        autoCompleteType='off'
        {...other}
      />
    );
  }

  return (
    <View style={[styles.labelInputView, style]}>
      <Text style={styles.label}>{text}</Text>
      <View style={styles.inputWrapper}>
        {inner}
        {scan}
      </View>
    </View>
  );
}
